<template>
  <iButton
    variant="text"
    icon-left="material-symbols:sentiment-satisfied-outline-rounded"
    :style-overrides="REACTION"
    :aria-pressed="String(open)"
    aria-label="Emoji"
    data-test="story-comments-emoji"
    @mousedown.prevent
    @click="$emit('toggle')"
  />
</template>

<script>
import { injectMessageComposer } from "@bloglovin/vue-component-library";

const REACTION = Object.freeze({
  standardPaddingLeft: "extraSmall",
  standardPaddingRight: "extraSmall",
});

export default {
  name: "StoryCommentEmojiButton",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["toggle"],
  expose: ["insert"],
  setup() {
    return { messageComposer: injectMessageComposer("StoryCommentEmojiButton") };
  },
  data() {
    return { REACTION };
  },
  methods: {
    insert(emoji) {
      this.messageComposer.focus();
      this.messageComposer.controller.beforeInput(new InputEvent("beforeinput", { inputType: "insertText", data: emoji, cancelable: true }));
    },
  },
};
</script>
